export const APP_INTRO_TOUR_ALIAS = {
  CALENDAR: "calendar",
  PACKAGES: "packages",
  CHAT: "chat",
  MARKETING_ANALYTICS: "marketing_analytics",
  SOCIAL_MEDIA_CALENDAR: "social_media_calendar",
}
